import * as React from 'react';
import type { Props as HybridLinkProps } from '../HybridLink/HybridLink';
import HybridLink from '../HybridLink/HybridLink';
import cn from '~modules/cn';
import Styles from './help-link.module.scss';

export type Props = HybridLinkProps;

const HelpLink = (props: Props) => <HybridLink {...props} className={cn(Styles.link, props.className)} />;

export default HelpLink;
